import { formatDistanceToNow } from 'date-fns'

// Note: Format is -> 2 days ago
export const formatRelativeTime = (date: number | Date) => {
  return formatDistanceToNow(date, { addSuffix: true, includeSeconds: true })
}
